import React from 'react'
import { Field } from 'formik'
import { Form, Col } from '_zari/core'

const ColorFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='COLOR' htmlFor='input-color' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='color'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-color'
              placeholder='Color del producto'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ColorFormGroup)
